import React, {useState}from 'react';
import {
    BrowserRouter as Router,
    Link,
    withRouter
} from "react-router-dom";

import Slider from 'react-slick';
import SoldIcon from '../sold-icon';
import StatusIcon from '../status-icon/status-icon';
import ListingFeedback from '../listing-feedback/listing-feedback';
import Modal from '../modal';
import UserForm from '../user-form';
import HOne from '../h-one';

import ThanksModal from '../thanks-modal';
import ListingHeader from '../listing-page/components/listing-header';
import ListingMedia from '../listing-page/components/listing-media';
import DealScoreContactForm from '../listing-page/components/deal-score-contact-form';
import DealScore from '../deal-score';
import KeyDealFeatures from '../key-deal-features';
import OfferResaleModal from '../offer-resale-modal';

import Parser from "html-react-parser";
import StringProcessingService from '../../services/string-processing-service';
import ConfigurationService from '../../services/configuration-service';
import ServerApi from '../../services/server-api-service';
import '../offer/offer-style.css';
import './offer-resale-style.css';
import '../../lib/slick-1.8.1/slick.css';
import '../../lib/slick-1.8.1/slick-theme.css';




function OfferResale(props){

    const configurationService = new ConfigurationService();
    const stringProcessingService = new StringProcessingService();

    let { 
        data,
        countSilderImg = 4,
        dealScore = true,
        dictionary, 
        width, 
        projectData, 
        internalLink = true,
        height,
        agent = null,
        country,
        viewDetailsColor = false,
    } = props;

    let analyseInfo = null;
    if(data.Analyse) analyseInfo = data.Analyse;
     const [isVisibleResaleModal, setIsVisibleResaleModal] = useState(false);
    // if(!Array.isArray(data.Media)) data.Media = JSON.parse(data.Media);

    let parsedPrice = stringProcessingService.convertToFormat(data.ListPrice.toString());
    const lang = configurationService.getCurrentLanguagePrefix();

    let locationIcon = require('../../elements/icons/s_location_offer.png');
    
    const renderImage = () => {
        let arrayOfImg = null;
        try {
            arrayOfImg = data.Media;
        } catch (error) {

        }
        if (Array.isArray(arrayOfImg) && arrayOfImg.length > 0) {
            const settingsSlider = {
                slidesToShow: 1,
            };
            return (
                <Slider {...settingsSlider}
                    centerMode={false}
                    focusOnSelect={true}
                    adaptiveHeight={true}
                >
                    {arrayOfImg.map((item, index) => {
                        if (index < countSilderImg) {
                            return (
                                <div key={index} >
                                    <img className="OfferImg" src={item.MediaUrl} alt="" />
                                </div>
                            )
                        }
                    })}
                </Slider>
            )
        } else {
            if (data.image !== undefined && data.image !== null && data.image !== '') {
                return (
                    <div >
                        <img key={data.id} className="OfferImg" src={data.image} alt="" />
                    </div>
                )
            } else {
                return (
                    <div >
                        <div className="OfferImg" />
                    </div>
                )
            }

        }
    }

    const  renderDealScore =  () => {
        if (dealScore) {
            const currentLanguage = configurationService.getCurrentLanguagePrefix();
            const imgExcellent = require(`../../elements/images/excellent_deal_${currentLanguage}.png`);
            const imgGood = require(`../../elements/images/good_deal_${currentLanguage}.png`);
            const imgGreat = require(`../../elements/images/great_deal_${currentLanguage}.png`);
            switch (data.DealRank) {
                case 2: {
                    return (<img className="DealScoreImg" src={imgGood} alt="" />)
                }
                case 3: {
                    return (<img className="DealScoreImg" src={imgGreat} alt="" />)
                }
                case 4: {
                    return (<img className="DealScoreImg" src={imgExcellent} alt="" />)
                }
                default: {
                    return null;
                }
            }
        }
    }

   

    const renderBottomBlock = () =>{
        return (
            <>
            <StatusIcon data={data}/>
                <div className="Left">
                    <div className="InfoRowItem">
                        {dictionary.bedrooms}
                        <span>{data.BedroomsTotal}</span>
                    </div>
                    <div className="InfoRowItem">
                        {dictionary.bathrooms}
                        <span>{data.BathroomsTotalDecimal}</span>
                    </div>
                    <div className="InfoRowItem">
                        {dictionary.footage}
                        <span>{data.LivingArea}</span>
                    </div>
                    <div className="InfoRowItem">
                        {dictionary.listing_price}:
                        <span>${parsedPrice}</span>
                    </div>
                </div>
                <div className="Right">
                    {renderDealScore()}
                </div>
            </>
        )
    }

    let link = `/${lang}/listing/${data.id}`;

    const subdomain = configurationService.getSubdomain();
    // if(subdomain){
    //     if(lang =='en') link = configurationService.getCurrentSite().replace(subdomain+'.','')+`listing/${data.id}`;
    //     else  link = configurationService.getCurrentSite().replace(subdomain,lang)+`listing/${data.id}`;
    // }

    link = ConfigurationService.getBaseUrl() + lang + `/listing/${data.id}`;
      

    return (
                <>
                    <div className={'OfferMain'} onClick={()=>{setIsVisibleResaleModal(true)}} >
                        <div className="TopBlockOffer">
                            <div className="OfferOverlay"></div>
                            <div className="OfferTitle">
                                {/* <span> Penthouse</span> */}
                                <div className="OfferLocation">
                                    <img src={locationIcon} alt=''></img>
                                    {`${data.City}, ${data.StateOrProvince} ${data.PostalCode}`}
                                </div>
                            </div>
                           
                            {renderImage()}
                        </div>
                        {!internalLink ? 
                            <div  className="BottomBlockOffer" onClick={()=>{setIsVisibleResaleModal(true)}}>
                                {renderBottomBlock()}
                            </div>
                        :
                            <a href={link} className="BottomBlockOffer">
                                {renderBottomBlock()}
                            </a>
                        }
                        <div className="ViewDetails">
                            <button 
                                className={"ViewMoreBtn Button " + (viewDetailsColor == 'inverse' ? 'ViewMoreBtnInverseColor' : '')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsVisibleResaleModal(true);
                                }}
                            >
                                {dictionary.view_details.toUpperCase()}
                            </button>
                        </div>
                    </div>

                    <OfferResaleModal
                        data={data}
                        dictionary={dictionary}
                        width={width}
                        projectData={projectData}
                        internalLink={internalLink}
                        height={height}
                        agent={agent}
                        country={country}
                        isVisible={isVisibleResaleModal}
                        setIsVisible={setIsVisibleResaleModal}
                    />
                       
                     {/* <Modal
                        ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                        closeModal={()=>{setIsVisibleResaleModal(false)}}
                        modalClass={'MessageModal OfferResaleModal'}
                        hiddenCloseIcon={true}
                        closeColor={'#fff'}
                        speed={0.5}
                        ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "0", alignItems: 'center', display:'block' }}
                        isVisible={isVisibleResaleModal}
                        > */}
                        {/* <HOne addclass={"xsmall"} align={"center"} title={dictionary.request_about.toUpperCase()} line={"none"} />
                        {projectData.logo ? <img src={projectData.logo === null ? null : `https://ngirealty.com/img/projects/${projectData.id}/${projectData.logo}`} className={"ProjectLogo"} alt=""></img> : null}
                        {data.urgency ?
                            <React.Fragment>
                                <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                    <defs>
                                        <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                            <stop offset="0" stopColor="#a96903" />
                                            <stop offset="0.258" stopColor="#aa6a02" />
                                            <stop offset="0.352" stopColor="#b07102" />
                                            <stop offset="0.418" stopColor="#b97d02" />
                                            <stop offset="0.472" stopColor="#c78e01" />
                                            <stop offset="0.518" stopColor="#daa401" />
                                            <stop offset="0.557" stopColor="#f0be00" />
                                            <stop offset="0.579" stopColor="#ffd100" />
                                            <stop offset="1" stopColor="#a96903" />
                                        </linearGradient>
                                    </defs>
                                    <br/>
                                    <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                        <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                    </g>
                                </svg>
                                <br/>
                                <div className={"FormText"}>
                                    {data.urgency}
                                </div>
                            </React.Fragment>
                            : (null)
                        } */}
                        {/* <UserForm
                            closeModal={()=>{setIsVisibleResaleModal(false)}}
                            countryCodeSelector = {true}
                            watcher={null}
                            className="MobileMessageModal"
                            thankModal={true}
                            clearForm={null}
                            message={dictionary.thank_you_deal}
                            initialMessage={`${dictionary.send_me_more_details_about_project} ${data.name}`}
                            selectedCountry={null}
                            saveCurrentSelectedCountry={null}
                            country={null}
                            topPartRow={true}
                            contactForm={contactForm}
                            handleInput={handleInput}
                            width={width}
                            secureInfo={true}
                            dictionary={dictionary}
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                        /> */}
                        {/* {projectData.cover_image ? 
                            <div className='CoverBlock'>
                                    <img src={`https://ngirealty.com/img/projects/${projectData.id}/${projectData.cover_image}`} alt='cover' className='CoverImage' />
                            </div>
                            : null    
                        } */}





                    {/* <div className="ListinPageBody" >
                        <ListingHeader
                            data = {data}
                            dictionary = {dictionary}
                            project = {projectData}
                            width = {width}
                            analyseInfo = {analyseInfo}
                            handleDealScore = {handleDealScore}
                        />
                        <div className={"PageListingLine"}>
                            <div className="PageListing">
                                <ListingMedia
                                    dictionary = {dictionary}
                                    width = {width}
                                    height= {height}
                                    analyseInfo= {analyseInfo}
                                    agent = {agent}
                                    handleDealScore= {handleDealScore}
                                    country = {country}
                                    contactInfo = {contactForm}
                                    selectedCountry = { selectedCountry}
                                    saveCurrentSelectedCountry = {saveCurrentSelectedCountry}
                                    handleInput = {handleInput}
                                    clearForm = {clearForm}
                                    openThanksModal = {(openThanksModal)}
                                    handleSwitchMedia = {handleSwitchMedia}
                                    currentImgId = {currentImgId}
                                    currentImg = {currentImg}
                                    data = {data}
                                    disableModal={true}
                                />

                                <div className="ListingPageMainInfoDiv">
                                    <KeyDealFeatures
                                        dictionary={dictionary}
                                        analyseInfo={analyseInfo}
                                        data={data}
                                        width={width}
                                    />

                               
                                </div>
                               <div className='ResaleMobileForm'>
                                    <div className='DealScoreAndContacts'>
                                        <DealScore
                                            dictionary={dictionary}
                                            width={width}
                                            analyseInfo={analyseInfo}
                                            handleDealScore={handleDealScore}
                                        />
                                        <DealScoreContactForm
                                            dictionary={dictionary}
                                            width={width}
                                            country={country}
                                            contactInfo={contactForm}
                                            selectedCountry={selectedCountry}
                                            agent={agent}
                                            analyseInfo={analyseInfo}
                                            data={data}
                                            saveCurrentSelectedCountry={saveCurrentSelectedCountry}
                                            handleInput={handleInput}
                                            clearForm={clearForm}
                                            openThanksModal={openThanksModal}
                                        />
                                    </div>
                               </div>
                        </div>
                    </div>
                    
                  
                    
                  
                </div> */}
                        
                    {/* </Modal>
                      <ThanksModal
                        isVisible={isVisibleThanksModal}
                        title={dictionary.thank_you}
                        message={dictionary.thank_you_deal}
                        closeModal={closeModal}
                    /> */}

                </>
                )
}

export default OfferResale;